'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var reactRedux = require('react-redux');
var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var createReactClass = _interopDefault(require('create-react-class'));
var createHistory = _interopDefault(require('history/lib/createBrowserHistory'));
var createLocation = _interopDefault(require('history/lib/createLocation'));
var urlParse = _interopDefault(require('url-parse'));
var pathToRegExp = _interopDefault(require('path-to-regexp'));
var queryStringParser = _interopDefault(require('query-string'));

/**
 * All the action types that redux-router-kit uses.
 */

var ROUTE_TO_INIT = '@@redux-router-kit/ROUTE_TO_INIT';
var ROUTE_TO_NEXT = '@@redux-router-kit/ROUTE_TO_NEXT';
var ROUTE_TO_FETCH = '@@redux-router-kit/ROUTE_TO_FETCH';
var ROUTE_TO = '@@redux-router-kit/ROUTE_TO';
var ROUTE_TO_WINDOW = '@@redux-router-kit/ROUTE_TO_WINDOW';
var ROUTE_TO_EXIT = '@@redux-router-kit/ROUTE_TO_EXIT';
var CANCEL_ROUTE = '@@redux-router-kit/CANCEL_ROUTE';
var MODIFY_ROUTE = '@@redux-router-kit/MODIFY_ROUTE';
var RESET_LOCATION = '@@redux-router-kit/RESET_LOCATION';

var ActionTypes = {
  ROUTE_TO_INIT: ROUTE_TO_INIT,
  ROUTE_TO_NEXT: ROUTE_TO_NEXT,
  ROUTE_TO_FETCH: ROUTE_TO_FETCH,
  ROUTE_TO: ROUTE_TO,
  ROUTE_TO_WINDOW: ROUTE_TO_WINDOW,
  ROUTE_TO_EXIT: ROUTE_TO_EXIT,
  CANCEL_ROUTE: CANCEL_ROUTE,
  MODIFY_ROUTE: MODIFY_ROUTE,
  RESET_LOCATION: RESET_LOCATION
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};



















var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};













var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/**
 * routeTo and cancelRoute action creators.
 */

var routeTo = function routeTo(href) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: ActionTypes.ROUTE_TO_INIT,
    payload: _extends({
      href: href
    }, options)
  };
};

var cancelRoute = function cancelRoute() {
  return {
    type: ActionTypes.CANCEL_ROUTE
  };
};

var resetLocation = function resetLocation(href) {
  return {
    type: ActionTypes.RESET_LOCATION,
    payload: {
      href: href
    }
  };
};

var Actions = {
  routeTo: routeTo,
  cancelRoute: cancelRoute,
  resetLocation: resetLocation
};

/**
 * Add `router` prop to your component that has the full state of the router.
 * Also adds routeTo and cancelRoute actions.
 */

var mapStateToProps = function mapStateToProps(state) {
  return {
    router: state.router
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    routeTo: function routeTo$$1() {
      dispatch(routeTo.apply(undefined, arguments));
    },
    cancelRoute: function cancelRoute$$1() {
      dispatch(cancelRoute.apply(undefined, arguments));
    }
  };
};

var connectRouter = function connectRouter(Component) {
  return reactRedux.connect(mapStateToProps, mapDispatchToProps)(Component);
};

/**
 * Add routeTo prop to your component.
 */

var mapDispatchToProps$1 = function mapDispatchToProps(dispatch) {
  return {
    routeTo: function routeTo$$1() {
      dispatch(routeTo.apply(undefined, arguments));
    }
  };
};

var connectRouteTo = function connectRouteTo(Component) {
  return reactRedux.connect(null, mapDispatchToProps$1)(Component);
};

/**
 * Add routeTo, cancelRoute props to your component.
 */

var mapDispatchToProps$2 = function mapDispatchToProps(dispatch) {
  return {
    routeTo: function routeTo$$1() {
      dispatch(routeTo.apply(undefined, arguments));
    },
    cancelRoute: function cancelRoute$$1() {
      dispatch(cancelRoute.apply(undefined, arguments));
    }
  };
};

var connectRouteActions = function connectRouteActions(Component) {
  return reactRedux.connect(null, mapDispatchToProps$2)(Component);
};

/**
 * "Normalizes" routes to be an object with a `path`. If a route points directly
 * to a component/function, the component will be on a `component` property.
 */

var normalizeRoute = function normalizeRoute(pathPattern, value) {
  var isComponent = typeof value === 'function' || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.hasOwnProperty('$$typeof');

  var route = {
    path: pathPattern
  };
  if (isComponent) {
    return _extends({}, route, {
      component: value
    });
  }
  if (value === null) {
    return route;
  }
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    return _extends({}, value, route);
  }
  if (typeof value === 'string') {
    return _extends({}, route, {
      name: value
    });
  }
  return _extends({}, route, {
    value: value
  });
};

/**
 * Given a route key (array of route paths), find the routes from the routing
 * table.
 */

var findRoutes = function findRoutes(routes, key) {
  var foundRoutes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (key == null) {
    return null;
  }
  if (!routes) {
    return null;
  }
  key = Array.isArray(key) ? key : [key];
  if (key.length === 0) {
    return null;
  }
  var routeValue = routes[key[0]];
  if (routeValue) {
    var route = normalizeRoute(key[0], routeValue);
    foundRoutes = foundRoutes.concat(route);
    if (key.length === 1) {
      return foundRoutes;
    }
    return findRoutes(route.routes, key.slice(1), foundRoutes);
  }
  return null;
};

/**
 * Take an element or object of elements and return props to be passed to a
 * parent component.
 */

var elementToProps = function elementToProps(element) {
  var props = {};
  if (React.isValidElement(element) || element === null) {
    props.children = element;
  } else if (element) {
    Object.keys(element).forEach(function (key) {
      props[key] = element[key];
    });
  }
  return props;
};

/**
 * Given a list of routes, create an element from any of the components defined
 * for those routes.
 */

var createElementFromRoutes = function createElementFromRoutes(_ref) {
  var query = _ref.query,
      router = _ref.router,
      matchedRoutes = _ref.matchedRoutes,
      _ref$createElement = _ref.createElement,
      createElement = _ref$createElement === undefined ? React.createElement : _ref$createElement;

  if (!matchedRoutes) {
    return null;
  }
  var element = matchedRoutes.reduceRight(function (childElement, route, matchedRouteIndex) {
    var component = route.component,
        components = route.components;

    var isComponent = typeof component === 'function' || (typeof component === 'undefined' ? 'undefined' : _typeof(component)) === 'object' && component.hasOwnProperty('$$typeof');

    if (!isComponent && (!component || (typeof components === 'undefined' ? 'undefined' : _typeof(components)) !== 'object')) {
      return childElement;
    }
    var routeProps = _extends({
      query: query,
      params: router.current.params,
      router: router,
      matchedRoutes: matchedRoutes,
      route: route,
      matchedRouteIndex: matchedRouteIndex
    }, elementToProps(childElement));
    if (component) {
      return createElement(component, routeProps);
    }
    return Object.keys(components).reduce(function (elements, key) {
      elements[key] = createElement(components[key], _extends({
        key: key }, routeProps));
    }, {});
  }, null);
  return element;
};

/**
 * Router takes `router` state from the store and a map of `routes`. Renders the
 * Component(s) from any matched routes.
 */

var Router = createReactClass({
  displayName: 'Router',


  propTypes: {
    router: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,

    render: PropTypes.func,
    renderBeforeCurrent: PropTypes.func,
    renderNotFound: PropTypes.func,
    renderDefault: PropTypes.func,
    renderRoot: PropTypes.func,
    renderComponent: PropTypes.func,
    renderRoutes: PropTypes.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: React.createElement
    };
  },
  matchedRoutes: function matchedRoutes() {
    var _props = this.props,
        router = _props.router,
        routes = _props.routes;


    if (router.current) {
      return findRoutes(routes, router.current.routeKey) || null;
    }

    return null;
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        router = _props2.router,
        renderBeforeCurrent = _props2.renderBeforeCurrent,
        renderRoutes = _props2.renderRoutes,
        renderComponent = _props2.renderComponent,
        renderDefault = _props2.renderDefault,
        renderRoot = _props2.renderRoot,
        renderNotFound = _props2.renderNotFound;


    var render = typeof children === 'function' ? children : this.props.render;

    var createElement = renderComponent || this.props.createElement;

    if (router.current) {

      var matchedRoutes = this.matchedRoutes();

      var baseProps = {
        query: router.current.query || {},
        router: router
      };

      var matchProps = _extends({}, baseProps, {
        matchedRoutes: matchedRoutes,
        params: router.current.params
      });

      if (render) {
        return render(matchProps);
      }

      if (!matchedRoutes) {

        if (renderNotFound) {
          return renderNotFound(baseProps);
        }

        return null;
      }

      if (renderRoutes) {
        return renderRoutes(matchProps);
      }

      var element = createElementFromRoutes(_extends({}, baseProps, {
        matchedRoutes: matchedRoutes,
        createElement: createElement
      }));

      var elementOrDefault = element == null && renderDefault ? renderDefault(matchProps) : element;

      var rootProps = _extends({}, matchProps, elementToProps(elementOrDefault));

      if (renderRoot) {
        return renderRoot(rootProps);
      }

      return elementOrDefault;
    }

    if (renderBeforeCurrent) {
      return renderBeforeCurrent({
        router: router
      });
    }

    if (render) {
      return render({
        router: router
      });
    }

    return null;
  }
});

/**
 * RouterContainer is already connected to the router state, so you only have to
 * pass in `routes`.
 */

var RouterContainer = createReactClass({
  displayName: 'RouterContainer',


  propTypes: {
    routes: PropTypes.object.isRequired
  },

  render: function render() {
    var router = this.props.router;


    return React.createElement(Router, _extends({}, this.props, { router: router }));
  }
});

var RouterContainer$1 = connectRouter(RouterContainer);

/**
 * Check if an event is a right-click.
 */

var isRightClick = function isRightClick() {
  var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // We can only make a determination if there's a `which` or `button`.
  if (event.which != null || event.button != null) {
    // jsdom only has event.button
    // srsly guise, why two different numbers for the same button???
    if (event.which == null) {
      // left button
      if (event.button !== 0) {
        return true;
      }
    } else {
      // left button
      if (event.which !== 1) {
        return true;
      }
    }
  }

  return false;
};

/**
 * Provides a way to subscribe to link clicking.
 */

var isListening = false;

var listeners = [];

var onLink = function onLink(config, handler) {

  listeners.push(handler);

  var unsubscribe = function unsubscribe() {
    for (var i = 0; i < listeners.length; i++) {
      if (listeners[i] === handler) {
        listeners.splice(i, 1);
        break;
      }
    }
  };

  if (isListening) {
    return unsubscribe;
  }

  // This code borrows heavily from:
  // https://github.com/cerebral/addressbar/blob/master/index.js

  // Check if IE history polyfill is added
  var location = window.history.location || window.location;

  var initialUrl = location.href;
  var uri = urlParse(initialUrl);
  var origin = uri.protocol + '//' + uri.host;

  var emitChange = function emitChange(url, event) {
    listeners.forEach(function (listener) {
      listener(event);
    });
  };

  var isSameOrigin = function isSameOrigin(href) {
    return href && href.indexOf(origin) === 0;
  };

  var getClickedHref = function getClickedHref(event) {

    if (isRightClick(event)) {
      return false;
    }

    // check for modifiers
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      return false;
    }

    if (event.defaultPrevented) {
      return false;
    }

    // ensure link
    var element = event.target;
    while (element && element.nodeName !== 'A') {
      element = element.parentNode;
    }
    if (!element || element.nodeName !== 'A') {
      return false;
    }

    // Ignore if tag has
    // 1. "download" attribute
    // 2. rel="external" attribute
    if (element.hasAttribute('download') || element.getAttribute('rel') === 'external') {
      return false;
    }

    var lowerCasedHref = element.href.toLowerCase();

    // Check for mailto: in the href
    if (lowerCasedHref.indexOf('mailto:') > -1) {
      return false;
    }
    // Check for javascript: in the href
    // eslint-disable-next-line no-script-url
    if (lowerCasedHref.indexOf('javascript:') > -1) {
      return false;
    }

    // check target
    if (element.target) {
      return false;
    }

    // x-origin
    if (config.shouldEmitCrossOriginLinks !== true && !isSameOrigin(element.href)) {
      return false;
    }

    return element.href;
  };

  window.addEventListener(document.ontouchstart ? 'touchstart' : 'click', function (event) {
    var href = getClickedHref(event);
    if (href) {
      emitChange(href, event);
    }
  });

  return unsubscribe;
};

/**
 * Checks if two states are equal. Lifted from
 * https://github.com/mjackson/history/blob/650d25bfd66da0bb68bcb97232c032b63c02ac9d/modules/LocationUtils.js#L26-L59
 * which unfortunately isn't available to the npm module.
 */

var statesAreEqual = function statesAreEqual() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (a === b) {
    return true;
  }

  var typeofA = a === null ? 'null' : typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = b === null ? 'null' : typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) {
    return false;
  }

  if (typeofA === 'object') {

    if (!Array.isArray(a)) {
      return Object.keys(a).every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  return false;
};

/**
 * Check if two hrefs differ only by hash.
 */

var isOnlyHrefHashChange = function isOnlyHrefHashChange(a, b) {
  if (!a || !b) {
    return false;
  }

  var aPath = a.split('#')[0];
  var bPath = b.split('#')[0];
  var hasHashInA = a.includes('#');
  var hasHashInB = b.includes('#');

  if (aPath !== bPath) {
    return false;
  }

  if (!hasHashInA && hasHashInB || hasHashInA && !hasHashInB) {
    return true;
  }

  if (!hasHashInA && !hasHashInB) {
    return false;
  }

  // If there is a hash, but the string before the hash matches, then it is a
  // hash only change. If the hash values are mismatching, or the same, it does
  // not matter because the browser will deal with that.
  if (aPath === bPath) {
    return true;
  }

  return false;
};

/**
 * Abstracts browser history as a component. `url` passed in will become the
 * new browser address. Any changes to the history will call the `onChange`
 * callback.
 *
 * All links will be wired up and also act as history events.
 *
 * Thanks to https://github.com/cerebral/addressbar and
 * https://github.com/christianalfoni/react-addressbar for the inspiration.
 *
 * A couple reasons to create a different implementation based on
 * https://github.com/mjackson/history:
 *
 * - addressbar doesn't keep track of history, so when you block navigation,
 *   you _always_ lose forward history.
 * - mjackson/history provides memory implementations which are nice for
 *   testing!
 */

var History = createReactClass({
  displayName: 'History',


  propTypes: {
    url: PropTypes.string,
    state: PropTypes.object,
    onChange: PropTypes.func,
    isWaiting: PropTypes.bool,
    history: PropTypes.object,
    shouldEmitCrossOriginLinks: PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      shouldEmitCrossOriginLinks: false
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(_ref) {
    var url = _ref.url,
        state = _ref.state,
        isWaiting = _ref.isWaiting;

    return this.waitingUrl != null && !isWaiting || url !== this.props.url || !statesAreEqual(state, this.props.state);
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var _this = this;

    var shouldEmitCrossOriginLinks = this.props.shouldEmitCrossOriginLinks;

    this.history = this.props.history || createHistory();
    if (this.props.url == null) {
      var unlistenCurrent = this.history.listen(function (location) {
        _this.initialUrl = '' + location.pathname + location.search + location.hash;
        _this.initialState = location.state;
      });
      unlistenCurrent();
    }
    this.unlistenBeforeLocationChange = this.history.listenBefore(this.onBeforeLocationChange);
    this.unsubscribeFromLinks = onLink({
      shouldEmitCrossOriginLinks: shouldEmitCrossOriginLinks
    }, function (event) {
      if (event.target.href) {
        // Anchor tags are frontend-only anyway, so they will get picked up
        // by history. Don't let them call `onChange`.
        var shouldEmit = true;
        if (typeof window !== 'undefined') {
          if (isOnlyHrefHashChange(window.location.href, event.target.href)) {
            shouldEmit = false;
          }
        }
        if (shouldEmit) {
          event.preventDefault();
          _this.props.onChange(event.target.href);
        }
      }
    });
    // Transition if necessary.
    this.transition({
      url: this.initialUrl != null ? this.initialUrl : undefined,
      state: this.initialState != null ? this.initialState : undefined,
      replace: true
    });
  },
  componentDidMount: function componentDidMount() {
    if (this.props.url == null && this.initialUrl != null) {
      this.props.onChange(this.initialUrl, this.initialState);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.unsubscribeFromLinks();
    this.unlistenBeforeLocationChange();
  },
  transition: function transition() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        replace = _ref2.replace,
        _ref2$url = _ref2.url,
        url = _ref2$url === undefined ? this.props.url : _ref2$url,
        _ref2$state = _ref2.state,
        state = _ref2$state === undefined ? this.props.state : _ref2$state;

    var location = createLocation(url);
    if (typeof state !== 'undefined') {
      location.state = state;
    }
    this.shouldIgnoreChange = true;
    if (replace || this.props.replace) {
      this.history.replace(location);
    } else {
      this.history.push(location);
    }
    this.shouldIgnoreChange = false;
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.waitingUrl != null) {
      if (this.waitingUrl === this.props.url && statesAreEqual(this.waitingState, this.props.state)) {
        this.finish();
      } else {
        this.transition();
      }
      this.finish = null;
      this.waitingUrl = null;
      this.waitingState = null;
    } else {
      this.transition();
    }
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(_ref3) {
    var url = _ref3.url,
        state = _ref3.state,
        isWaiting = _ref3.isWaiting;

    // Cancel synchronously.
    if (this.waitingUrl != null && !isWaiting) {
      if (this.waitingUrl !== url || !statesAreEqual(this.waitingState, state)) {
        this.finish(false);
      }
    }
  },
  onBeforeLocationChange: function onBeforeLocationChange(location, callback) {
    var newUrl = '' + location.pathname + location.search + location.hash;
    var newState = location.state;
    if (this.shouldIgnoreChange || newUrl === this.props.url && statesAreEqual(newState, this.props.state)) {
      this.shouldIgnoreChange = false;
      callback();
      return;
    }
    this.waitingUrl = newUrl;
    this.waitingState = newState;
    this.finish = function (result) {
      callback(result);
    };
    this.props.onChange(newUrl, newState);
  },
  render: function render() {
    return null;
  }
});

/**
 * RouterHistoryContainer is already connected to the router state, so you only
 * have to pass in `routes`. It also responds to history/click events and
 * dispatches routeTo actions appropriately.
 */

var RouterHistoryContainer = createReactClass({
  displayName: 'RouterHistoryContainer',

  propTypes: {
    routes: PropTypes.object.isRequired,
    shouldEmitCrossOriginLinks: PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      shouldEmitCrossOriginLinks: false
    };
  },
  onChangeAddress: function onChangeAddress(url, state) {
    this.props.routeTo(url, {
      state: state,
      isHistoryChange: true
    });
  },
  render: function render() {
    var _props = this.props,
        router = _props.router,
        shouldEmitCrossOriginLinks = _props.shouldEmitCrossOriginLinks;


    var url = router.current ? router.current.url : null;
    var state = router.current ? router.current.state : undefined;
    var replace = router.current ? router.current.replace : undefined;

    return [React.createElement(Router, _extends({ key: 'router' }, this.props, { router: router })), React.createElement(History, {
      key: 'history',
      shouldEmitCrossOriginLinks: shouldEmitCrossOriginLinks,
      history: this.props.history,
      url: url,
      state: state,
      replace: replace,
      isWaiting: !!router.next,
      onChange: this.onChangeAddress
    })];
  }
});

var RouterHistoryContainer$1 = connectRouter(RouterHistoryContainer);

/**
 * Just a little boilerplate for the routing middleware.
 */

var noPayloadActions = defineProperty({}, ActionTypes.CANCEL_ROUTE, true);

var createMiddleware = function createMiddleware(_ref, handlers) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;


  return function (next) {

    return function (action) {

      if (!action || !action.type || !handlers[action.type]) {
        return next(action);
      }

      if (!action.payload && !noPayloadActions[action.type]) {
        console.warn('Ignoring routing action ' + action.type + ' without payload.');
        return undefined;
      }

      var router = getState().router;

      if (!router) {
        console.warn('Ignoring routing action when there is no router key on the state. Did you forget the reducer?');
        return undefined;
      }

      return handlers[action.type]({ router: router, getState: getState, dispatch: dispatch, next: next, action: action });
    };
  };
};

/**
 * Exports `parseUrl` for, well, parsing URLs!
 */

var schemeMatcher = /^([a-zA-Z]*\:)?\/\//;

var hasScheme = function hasScheme(url) {
  if (typeof url !== 'string') {
    return false;
  }
  return schemeMatcher.test(url);
};

var parseUrl = function parseUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var baseUrl = arguments[1];

  if (!hasScheme(url)) {
    if (!hasScheme(baseUrl)) {
      throw new Error('Must provide scheme in url or baseUrl to parse. `url` provided: ' + url + '. `baseUrl` provided: ' + baseUrl + '.');
    }
  }

  if (!hasScheme(url)) {
    if (url[0] !== '/') {
      throw new Error('Only absolute URLs are currently supported. `url` provided: ' + url);
    }
  }

  var urlObj = urlParse(url, baseUrl);

  return {
    protocol: urlObj.protocol,
    host: urlObj.host,
    hostname: urlObj.hostname,
    port: urlObj.port,
    pathname: urlObj.pathname,
    hash: urlObj.hash,
    search: urlObj.query,
    origin: urlObj.host ? urlObj.protocol + '//' + urlObj.host : '',
    href: urlObj.href
  };
};

/**
 * Exports `routabelUrl` to make sure that we can route to the url.
 */

var isSameOrigin = function isSameOrigin(href) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return href.substring(0, origin.length) === origin;
};

var routableUrl = function routableUrl(href) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!isSameOrigin(href, origin)) {
    return null;
  }
  return href.substring(origin.length);
};

/**
 * Exports `matchRoutes` which takes a routing table and a url and finds the
 * set of nested routes to match that url. Returns an object like:
 *
 * {
 *   routes: [
 *     {
 *       // root route
 *     },
 *     {
 *       // todos route
 *     },
 *     {
 *       // todo route
 *     }
 *   ],
 *   key: ['/', 'todos', ':id'],
 *   params: {
 *     id: '123'
 *   },
 *   query: {}
 * }
 */

/**
 * createRouteMatcher adapted from:
 * https://github.com/pillarjs/path-match/blob/f461d324572404943fbde1562dddee6e03fe383c/index.js
 * Mainly this is to avoid the http-errors dependency.
 */

// Convert path to a compiled route matcher.
var createRouteMatcher = function createRouteMatcher(pathPattern) {
  var keys = [];
  var re = pathToRegExp(pathPattern, keys);

  return function (pathname, params) {
    var m = re.exec(pathname);
    if (!m) {
      return false;
    }

    params = params || {};

    var key = void 0;
    var param = void 0;
    for (var i = 0; i < keys.length; i++) {
      key = keys[i];
      param = m[i + 1];
      if (!param) {
        continue;
      }
      params[key.name] = decodeURIComponent(param);
      if (key.repeat) {
        params[key.name] = params[key.name].split(key.delimiter);
      }
    }

    return params;
  };
};

var cache = {};

var compiledRouteMatcher = function compiledRouteMatcher(pathPattern) {
  if (!(pathPattern in cache)) {
    cache[pathPattern] = createRouteMatcher(pathPattern);
  }
  return cache[pathPattern];
};

var matchPathnameToPattern = function matchPathnameToPattern(pathname, pathPattern) {
  // Index match.
  if (pathname === '' && pathPattern === '.') {
    return {};
  }
  var matchRoute = compiledRouteMatcher(pathPattern);
  return matchRoute(pathname);
};

var extendResult = function extendResult(result, pathPattern, route, params) {
  return {
    key: result.key.concat(pathPattern),
    routes: result.routes.concat(route),
    params: _extends({}, result.params, params)
  };
};

/**
 * Route matching adapted from:
 * https://github.com/ReactTraining/react-router/blob/800991cd2044293718fccd3763b9d91c2f811296/modules/matchRoutes.js
 * But made to work with simple regexp-based routes above.
 */

var deepMatchRoutes = function deepMatchRoutes(routes, pathname, remainingPathname) {
  var result = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    key: [],
    routes: [],
    params: {}
  };


  for (var pathPattern in routes) {

    var routeValue = routes[pathPattern];
    if (!routeValue) {
      break;
    }

    var testPathname = pathPattern[0] === '/' ? pathname : remainingPathname;
    var params = matchPathnameToPattern(testPathname, pathPattern);

    if (params) {
      var route = normalizeRoute(pathPattern, routeValue);
      var nextResult = extendResult(result, pathPattern, route, params);
      if (route.routes) {
        var deeperMatch = deepMatchRoutes(route.routes, pathname, '', nextResult);
        if (deeperMatch) {
          return deeperMatch;
        }
      }
      return nextResult;
    }

    if (routeValue.routes || routeValue.fetch) {
      if (pathPattern.charAt(pathPattern.length - 1) !== '*') {
        var trailingSlash = pathPattern.charAt(pathPattern.length - 1) === '/' ? '' : '/';
        var wildPathPattern = '' + pathPattern + trailingSlash + ':__remainingPathnames__*';
        var wildParams = matchPathnameToPattern(testPathname, wildPathPattern);
        if (wildParams) {
          var newRemainingPathnames = wildParams.__remainingPathnames__,
              otherParams = objectWithoutProperties(wildParams, ['__remainingPathnames__']);

          var newRemainingPathname = newRemainingPathnames.join('/');
          var _route = normalizeRoute(pathPattern, routeValue);
          var _nextResult = extendResult(result, pathPattern, _route, otherParams);
          if (routeValue.routes) {
            return deepMatchRoutes(_route.routes, pathname, newRemainingPathname, _nextResult);
          } else {
            // Fetch result.
            return _nextResult;
          }
        }
      }
    }
  }

  return null;
};

var matchRoutes = function matchRoutes(routes, url) {

  if (!routes || (typeof routes === 'undefined' ? 'undefined' : _typeof(routes)) !== 'object') {
    throw new Error('matchRoutes requires routes to be an object.');
  }

  if (typeof url !== 'string') {
    throw new Error('matchRotes requires url to be a string.');
  }

  var urlWithQueryString = url.split('#')[0];
  var pathname = urlWithQueryString.split('?')[0];

  var match = deepMatchRoutes(routes, pathname, pathname);

  if (match) {
    var queryStringAndHash = url.substring(pathname.length);
    var queryString = queryStringAndHash.split('#')[0];
    var query = queryStringParser.parse(queryString);

    return _extends({}, match, {
      query: query
    });
  }

  return null;
};

/**
 * Just like it says: clones routes for a route key (array of route paths). When
 * fetching async routes, we want to update the routing table but not mutate
 * what was passed in. So we clone the pieces we need.
 */

var cloneRoutesForKey = function cloneRoutesForKey(routes, key) {
  routes = _extends({}, routes);
  if (!key || key.length === 0) {
    return routes;
  }
  var route = routes[key[0]];
  if (!route || typeof route === 'function' || (typeof route === 'undefined' ? 'undefined' : _typeof(route)) !== 'object') {
    return routes;
  }
  var routeCopy = _extends({}, route);
  routes[key[0]] = routeCopy;
  if (!routeCopy.routes) {
    return routes;
  }
  routeCopy.routes = cloneRoutesForKey(routeCopy.routes, key.slice(1));
  return routes;
};

/**
 * Check if two locations differ only by hash.
 */

var isOnlyLocationHashChange = function isOnlyLocationHashChange(locationA, locationB) {
  if (locationA && locationB) {
    var pathAndQueryA = "" + locationA.origin + locationA.pathname + locationA.search;
    var pathAndQueryB = "" + locationB.origin + locationB.pathname + locationB.search;
    return pathAndQueryA === pathAndQueryB;
  }
  return false;
};

/**
 * Creates a router middleware for a set of routes. Does a bunch of things:
 *
 * - Adds in location metadata and kicks off ROUTE_TO_NEXT actions.
 * - Calls any onEnter/onLeave hooks before the final ROUTE_TO action.
 * - Handles "exiting" of routes to the server.
 * - Tries its best to handle events that should open a tab or window instead of
 *   routing.
 * - Handles async routes.
 */

var UNDEFINED_HREF = 'http://example.com/';

var _id = 0;
var uniqueId = function uniqueId() {
  _id++;
  return _id;
};

var browserUrl = function browserUrl() {
  if (typeof window === 'undefined') {
    return UNDEFINED_HREF;
  }
  if (!window || !window.location) {
    return UNDEFINED_HREF;
  }
  return window.location.href;
};

var baseUrl = browserUrl();

var cleanEvent = function cleanEvent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      metaKey = _ref.metaKey,
      ctrlKey = _ref.ctrlKey,
      shiftKey = _ref.shiftKey,
      defaultPrevented = _ref.defaultPrevented,
      which = _ref.which,
      button = _ref.button;

  return { metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey, defaultPrevented: defaultPrevented, which: which, button: button };
};

var openWindow = function openWindow() {
  if (typeof window !== 'undefined') {
    var _window;

    (_window = window).open.apply(_window, arguments);
  }
};

var isOnlyHashChange = function isOnlyHashChange(current, next) {
  if (current && next) {
    return isOnlyLocationHashChange(current.location, next.location);
  }
  return false;
};

// Remove routes from the beginning of list a that are the same in route b.
var removeSameParentRoutes = function removeSameParentRoutes(a, b) {
  a = a || [];
  b = b || [];
  if (a.length > 0 && b.length > 0 && a[0].path === b[0].path) {
    return removeSameParentRoutes(a.slice(1), b.slice(1));
  }
  return a;
};

var routeMeta = function routeMeta(match) {
  if (match && match.routes) {
    return match.routes.reduce(function (currMeta, route) {
      var extraStateFromFunction = typeof route.assign === 'function' ? route.assign({
        params: currMeta.params,
        query: currMeta.query
      }) : undefined;
      var extraState = (typeof extraStateFromFunction === 'undefined' ? 'undefined' : _typeof(extraStateFromFunction)) === 'object' && typeof extraStateFromFunction !== 'function' && extraStateFromFunction || _typeof(route.assign) === 'object' && route.assign || {};
      return _extends({
        name: route.name,
        params: currMeta.params,
        query: currMeta.query
      }, extraState);
    }, {
      params: match.params,
      query: match.query
    });
  }

  return {};
};

var noOpBatchedUpdates = function noOpBatchedUpdates(cb) {
  cb();
};

var createRouterMiddleware = function createRouterMiddleware() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      routes = _ref2.routes,
      _ref2$batchedUpdates = _ref2.batchedUpdates,
      batchedUpdates = _ref2$batchedUpdates === undefined ? noOpBatchedUpdates : _ref2$batchedUpdates,
      _ref2$fetchRoute = _ref2.fetchRoute,
      fetchRouteFn = _ref2$fetchRoute === undefined ? function (route) {
    console.error('No fetchRoute function provided for route:', route);
    return route;
  } : _ref2$fetchRoute;

  if (!routes || !((typeof routes === 'undefined' ? 'undefined' : _typeof(routes)) === 'object')) {
    throw new Error('Must provide mapping from route strings to route objects.');
  }

  var routeListeners = [];

  var emitRoutesChanged = function emitRoutesChanged() {
    return routeListeners.forEach(function (handler) {
      return handler(routes);
    });
  };

  var setRoutes = function setRoutes(newRoutes) {
    routes = newRoutes;
    emitRoutesChanged();
  };

  var fetchRoute = function fetchRoute(route) {
    if (typeof route.fetch === 'function') {
      return Promise.resolve(route.fetch());
    }
    return Promise.resolve(fetchRouteFn(route));
  };

  var fetchAndUpdateRoutes = function fetchAndUpdateRoutes(url) {
    var match = matchRoutes(routes, url);
    if (match && match.routes) {
      // Find the new route.
      var matchedRoutes = findRoutes(routes, match.key);
      if (matchedRoutes) {
        var lastRoute = matchedRoutes[matchedRoutes.length - 1];
        if (lastRoute.fetch) {
          return fetchRoute(lastRoute).then(function (resultRoute) {
            // Make sure we still have a place to put this.
            matchedRoutes = findRoutes(routes, match.key);
            if (!matchedRoutes) {
              return undefined;
            }
            var newRoutes = cloneRoutesForKey(routes, match.key);
            var newRoute = _extends({}, resultRoute, {
              fetch: undefined
            });
            var lastKey = match.key[match.key.length - 1];
            var parentRoutes = findRoutes(newRoutes, match.key.slice(0, match.key.length - 1)) || [];
            var parentContainer = parentRoutes.length > 0 ? parentRoutes[parentRoutes.length - 1].routes : newRoutes;
            parentContainer[lastKey] = newRoute;
            setRoutes(newRoutes);
            return fetchAndUpdateRoutes(url);
          });
        }
      }
    }
    return Promise.resolve();
  };

  var inFlightNext = null;

  var middleware = function middleware(store) {
    var _handlers;

    var handlers = (_handlers = {}, defineProperty(_handlers, ActionTypes.ROUTE_TO_INIT, function (_ref3) {
      var router = _ref3.router,
          dispatch = _ref3.dispatch,
          action = _ref3.action,
          getState = _ref3.getState;

      var parsedUrl = parseUrl(action.payload.href, router.href || baseUrl);

      var url = routableUrl(parsedUrl.href, router.origin || parsedUrl.origin);

      var nextMatch = url != null && matchRoutes(routes, url);

      var assign = routeMeta(nextMatch);

      var routeId = uniqueId();

      var nextAction = {
        type: ActionTypes.ROUTE_TO_NEXT,
        payload: _extends({}, action.payload, {
          event: cleanEvent(action.payload.event || {}),
          isHistoryChange: action.payload.isHistoryChange
        }),
        meta: {
          url: url,
          location: parsedUrl,
          assign: assign,
          _routeId: routeId,
          routeKey: nextMatch && nextMatch.key
        }
      };

      if (nextMatch && nextMatch.routes) {
        var leafRoute = nextMatch.routes[nextMatch.routes.length - 1];
        if (leafRoute.fetch) {
          var fetchAction = _extends({}, nextAction);
          fetchAction.type = ActionTypes.ROUTE_TO_FETCH;
          dispatch(fetchAction);
          return fetchAndUpdateRoutes(url).then(function () {
            var nextRouter = getState().router;
            if (nextRouter.fetch && nextRouter.fetch._routeId === routeId) {
              var newNextMatch = url != null && matchRoutes(routes, url);
              var newAssign = routeMeta(newNextMatch);
              var newNextAction = _extends({}, nextAction, {
                meta: _extends({}, nextAction.meta, {
                  assign: newAssign,
                  routeKey: newNextMatch && newNextMatch.key
                })
              });
              dispatch({
                type: ActionTypes.ROUTE_TO_FETCH,
                payload: null
              });
              return dispatch(newNextAction);
            }
            return undefined;
          });
        }
      }

      return dispatch(nextAction);
    }), defineProperty(_handlers, ActionTypes.ROUTE_TO_NEXT, function (_ref4) {
      var currentRouter = _ref4.router,
          getState = _ref4.getState,
          dispatch = _ref4.dispatch,
          action = _ref4.action,
          next = _ref4.next;
      var meta = action.meta;
      var event = action.payload.event;


      if (event.defaultPrevented) {
        return Promise.resolve();
      }

      if (isRightClick(event)) {
        return Promise.resolve();
      }

      if (event.metaKey || event.ctrlKey || event.shiftKey) {
        return Promise.resolve(dispatch(_extends({}, action, {
          type: ActionTypes.ROUTE_TO_WINDOW
        })));
      }

      // Don't allow routing to the exact same location as next.
      if (currentRouter.next && currentRouter.next.location.href === meta.location.href && statesAreEqual(currentRouter.next.state, action.payload.state)) {
        // Unless we change `exit` flag, in which case we can modify
        // the next route.
        if (!!currentRouter.next.exit !== !!action.payload.exit) {
          dispatch({
            type: ActionTypes.MODIFY_ROUTE,
            payload: {
              exit: !!action.payload.exit
            }
          });
        }
        return inFlightNext || Promise.resolve();
      }

      // If there's a route in flight, auto cancel it.
      if (currentRouter.next) {
        dispatch(Actions.cancelRoute());
      }

      // Don't allow routing to the exact same location as current.
      if (currentRouter.current && currentRouter.current.location.href === meta.location.href && statesAreEqual(currentRouter.current.state, action.payload.state)) {
        return Promise.resolve();
      }

      var result = next(action);
      var routeTo$$1 = function routeTo$$1() {
        dispatch(Actions.routeTo.apply(Actions, arguments));
      };
      var cancelRoute$$1 = function cancelRoute$$1() {
        dispatch(Actions.cancelRoute.apply(Actions, arguments));
      };
      var nextRoutes = findRoutes(routes, meta.routeKey);
      var currMatch = currentRouter.current && matchRoutes(routes, currentRouter.current.url);

      inFlightNext = Promise.resolve(result)
      // Handle onLeave for the current route.
      .then(function () {
        var _getState = getState(),
            router = _getState.router;

        if (router.next && router.next._routeId === meta._routeId) {
          if (router.current) {
            if (currMatch && currMatch.routes) {
              var currLeavingRoutes = removeSameParentRoutes(currMatch.routes, nextRoutes);

              return currLeavingRoutes.reduceRight(function (promise, route) {
                if (route.onLeave && typeof route.onLeave === 'function') {
                  return (promise || Promise.resolve()).then(function () {
                    return route.onLeave({
                      routeTo: routeTo$$1,
                      cancelRoute: cancelRoute$$1,
                      getState: getState,
                      dispatch: dispatch,
                      action: action,
                      router: router
                    });
                  });
                }
                return promise;
              }, undefined);
            }
          }
        }
        return undefined;
      })
      // Handle onEnter for the next route.
      .then(function () {
        var _getState2 = getState(),
            router = _getState2.router;

        if (router.next && router.next._routeId === meta._routeId) {
          if (nextRoutes) {
            var nextEnteringRoutes = removeSameParentRoutes(nextRoutes, currMatch && currMatch.routes);

            return nextEnteringRoutes.reduce(function (promise, route) {
              if (route.onEnter && typeof route.onEnter === 'function') {
                return (promise || Promise.resolve()).then(function () {
                  return route.onEnter({
                    routeTo: routeTo$$1,
                    cancelRoute: cancelRoute$$1,
                    getState: getState,
                    dispatch: dispatch,
                    action: action,
                    router: router
                  });
                });
              }
              return promise;
            }, undefined);
          }
        }
        return undefined;
      })
      // Finally, move to the next route.
      .then(function () {
        var _getState3 = getState(),
            router = _getState3.router;

        var dispatchResult = void 0;
        // Finish the route if we're still routing the same route.
        if (router.next && router.next._routeId === meta._routeId) {
          batchedUpdates(function () {
            dispatchResult = dispatch(_extends({}, action, {
              type: router.next.exit ? ActionTypes.ROUTE_TO_EXIT : ActionTypes.ROUTE_TO
            }));
          });
        }
        return dispatchResult;
      });

      return inFlightNext;
    }), defineProperty(_handlers, ActionTypes.ROUTE_TO, function (_ref5) {
      var router = _ref5.router,
          dispatch = _ref5.dispatch,
          next = _ref5.next,
          action = _ref5.action;

      inFlightNext = null;
      var meta = action.meta;


      var nextRoutes = findRoutes(routes, meta.routeKey);

      // Only allow exiting if we have already routed, to prevent loops.
      if (router.current) {
        // Probably should get route `exit` into state, but we need to
        // differenciate between route exits and legitimate redirects.
        if (!nextRoutes || nextRoutes.some(function (route) {
          return route.exit;
        })) {
          return dispatch(_extends({}, action, {
            type: ActionTypes.ROUTE_TO_EXIT
          }));
        }
      }

      return next(action);
    }), defineProperty(_handlers, ActionTypes.ROUTE_TO_WINDOW, function (_ref6) {
      var action = _ref6.action;

      inFlightNext = null;
      var meta = action.meta;
      var event = action.payload.event;


      if (event.shiftKey) {
        openWindow(meta.location.href, '_blank');
        return;
      }

      openWindow(meta.location.href);
    }), defineProperty(_handlers, ActionTypes.ROUTE_TO_EXIT, function (_ref7) {
      var action = _ref7.action,
          next = _ref7.next,
          router = _ref7.router;

      inFlightNext = null;
      var meta = action.meta;

      // If we change back to ROUTE_TO here, we DO NOT RE-DISPATCH.
      // If we did, we could loop back around.
      // This logic could move to ROUTE_TO to avoid this, but it's nice to
      // only worry about window here. Alternatively, we could add a flag to
      // avoid looping, but that seems more confusing.

      if (typeof window !== 'undefined') {
        if (isOnlyHashChange(router.current, meta)) {
          // Browser wouldn't have reloaded this, so we won't either.
          // Probably should add a `reload` option later to force this.
          return next(_extends({}, action, {
            type: ActionTypes.ROUTE_TO
          }));
        } else if (isOnlyHashChange(window, meta)) {
          // Need for force a change, because window is out of sync.
          // Cancel may not have made it through yet to History.
          window.location.hash = meta.location.hash;
          window.location.reload();
        } else if (action.payload.replace && window.location.replace) {
          window.location.replace(meta.location.href);
        } else {
          window.location.href = meta.location.href;
        }
      } else if (meta.url) {
        // If we have a url and no window, then go ahead with ROUTE_TO.
        // (Because origin matched anyway.)
        return next(_extends({}, action, {
          type: ActionTypes.ROUTE_TO
        }));
      }
      return undefined;
    }), defineProperty(_handlers, ActionTypes.CANCEL_ROUTE, function (_ref8) {
      var action = _ref8.action,
          next = _ref8.next;

      inFlightNext = null;
      return next(action);
    }), defineProperty(_handlers, ActionTypes.RESET_LOCATION, function (_ref9) {
      var action = _ref9.action,
          next = _ref9.next;

      var newNextAction = _extends({}, action, {
        payload: {
          location: parseUrl(action.payload.href || browserUrl(), baseUrl)
        }
      });

      return next(newNextAction);
    }), _handlers);

    return createMiddleware(store, handlers);
  };

  middleware.setRoutes = setRoutes;

  middleware.onRoutesChanged = function (handler) {
    routeListeners.push(handler);

    var unsubscribe = function unsubscribe() {
      for (var i = 0; i < routeListeners.length; i++) {
        if (routeListeners[i] === handler) {
          routeListeners.splice(i, 1);
          break;
        }
      }
    };

    return unsubscribe;
  };

  return middleware;
};

var _handlers;

/**
 * Handles all the state changes, of course.
 */

var defaultState = {
  current: null,
  previous: null,
  next: null
};

var undefinedAsNull = function undefinedAsNull(value) {
  return value === undefined ? null : value;
};

var handlers = (_handlers = {}, defineProperty(_handlers, ActionTypes.CANCEL_ROUTE, function (state) {
  return _extends({}, state, {
    next: null
  });
}), defineProperty(_handlers, ActionTypes.MODIFY_ROUTE, function (state, action) {
  if (!state.next) {
    return state;
  }
  var payload = action.payload;

  return _extends({}, state, {
    next: _extends({}, state.next, {
      exit: !!payload.exit
    })
  });
}), defineProperty(_handlers, ActionTypes.ROUTE_TO_NEXT, function (state, action) {
  var payload = action.payload,
      meta = action.meta;


  return _extends({}, state, {
    next: _extends({}, meta.assign, {
      _routeId: meta._routeId,
      routeKey: meta.routeKey,
      location: meta.location,
      url: meta.url,
      state: undefinedAsNull(payload.state),
      replace: !!payload.replace,
      exit: !!payload.exit
    }),
    origin: state.origin || meta.location.origin
  });
}), defineProperty(_handlers, ActionTypes.ROUTE_TO_FETCH, function (state, action) {
  var payload = action.payload,
      meta = action.meta;


  if (!payload) {
    return _extends({}, state, {
      fetch: null
    });
  }

  return _extends({}, state, {
    next: null,
    fetch: _extends({}, meta.assign, {
      _routeId: meta._routeId,
      routeKey: meta.routeKey,
      location: meta.location,
      url: meta.url,
      state: undefinedAsNull(payload.state),
      replace: !!payload.replace,
      exit: !!payload.exit
    }),
    origin: state.origin || meta.location.origin
  });
}), defineProperty(_handlers, ActionTypes.ROUTE_TO, function (state, action) {
  var payload = action.payload,
      meta = action.meta;


  return _extends({}, state, {
    previous: !payload.replace && state.current || state.previous,
    current: _extends({}, meta.assign, {
      _routeId: meta._routeId,
      routeKey: meta.routeKey,
      location: meta.location,
      url: meta.url,
      state: undefinedAsNull(payload.state),
      replace: !!payload.replace
    }),
    next: null,
    origin: state.origin || meta.location.origin
  });
}), defineProperty(_handlers, ActionTypes.RESET_LOCATION, function (state, action) {
  var payload = action.payload;


  return _extends({}, state, {
    current: _extends({}, state.current, {
      location: payload.location
    }),
    origin: payload.location.origin
  });
}), _handlers);

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];

  if (action) {
    if (handlers[action.type]) {
      return handlers[action.type](state, action);
    }
  }

  return state;
}

/**
 * Export all the things!
 */

exports.connectRouter = connectRouter;
exports.connectRouteTo = connectRouteTo;
exports.connectRouteActions = connectRouteActions;
exports.Router = Router;
exports.RouterContainer = RouterContainer$1;
exports.RouterHistoryContainer = RouterHistoryContainer$1;
exports.createRouterMiddleware = createRouterMiddleware;
exports.matchRoutes = matchRoutes;
exports.findRoutes = findRoutes;
exports.createElementFromRoutes = createElementFromRoutes;
exports.RouterActions = Actions;
exports.RouterActionTypes = ActionTypes;
exports.routerReducer = reducer;
exports.routeTo = routeTo;
exports.cancelRoute = cancelRoute;
exports.resetLocation = resetLocation;
exports.ROUTE_TO_INIT = ROUTE_TO_INIT;
exports.ROUTE_TO_NEXT = ROUTE_TO_NEXT;
exports.ROUTE_TO_FETCH = ROUTE_TO_FETCH;
exports.ROUTE_TO = ROUTE_TO;
exports.ROUTE_TO_WINDOW = ROUTE_TO_WINDOW;
exports.ROUTE_TO_EXIT = ROUTE_TO_EXIT;
exports.CANCEL_ROUTE = CANCEL_ROUTE;
exports.MODIFY_ROUTE = MODIFY_ROUTE;
exports.RESET_LOCATION = RESET_LOCATION;
